import React from 'react';
import { useFormContext } from 'react-hook-form';

import { Select, Option } from '@simplybusiness/mobius-simplybusiness';

import ErrorMessage from '../atoms/ErrorMessage';

const exemptionReasons = new Map([
  [
    'Your employees are paid as self-employed or paid via an agency',
    'My workers are self-employed or paid through an agency',
  ],
  [
    'Your employees each earn less than £118 a week',
    'My employees earn less than £118 a week',
  ],
  [
    'Your employees are unpaid volunteers',
    'My workers are unpaid volunteers',
  ],
  [
    'Your business is based in the Channel Islands or the Isle of Man',
    'My business is based in the Channel Islands or the Isle of Man',
  ],
  [
    'Your business does not employ anyone',
    'I don\'t have any employees',
  ],
  [
    'Your business is not HMRC registered',
    'My business isn\'t registered with HMRC',
  ],
]);

const ExemptionReasonInput = () => {
  const { register, errors } = useFormContext();

  const validateValueInclusion = (value) => !!exemptionReasons.has(value);

  return (
    <>
      <Select
        label="Please tell us the reason"
        name="exemptionReason"
        ref={register({ validate: validateValueInclusion })}
        validationState={errors.exemptionReason ? 'invalid' : ''}
        marginBottom={4}
      >
        <Option value="">Please Select</Option>

        {Array.from(exemptionReasons).map(([optionExemptionReasonValue, optionExemptionReasonText]) => (
          <Option key={optionExemptionReasonValue} value={optionExemptionReasonValue}>
            {optionExemptionReasonText}
          </Option>
        ))}
      </Select>
      { errors.exemptionReason
        && <ErrorMessage>Please select exemption reason from the list above.</ErrorMessage> }
    </>
  );
};

export default ExemptionReasonInput;
